import type { ReactNode } from "react";

type SectionHeadingProps = {
  eyebrow?: string;
  title: ReactNode;
  description?: string;
  action?: ReactNode;
};

const SectionHeading = ({ eyebrow, title, description, action }: SectionHeadingProps) => (
  <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
    <div className="max-w-2xl">
      {eyebrow ? (
        <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
          <span className="h-[2px] w-6 bg-accent-500" />
          {eyebrow}
        </p>
      ) : null}
      <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[28px]">
        {title}
      </h2>
      {description ? (
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{description}</p>
      ) : null}
    </div>
    {action ? <div className="shrink-0">{action}</div> : null}
  </div>
);

export default SectionHeading;